import { render, staticRenderFns } from "./oldnews.vue?vue&type=template&id=1ae267cf&scoped=true&"
import script from "./oldnews.vue?vue&type=script&lang=js&"
export * from "./oldnews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae267cf",
  null
  
)

export default component.exports